import { STYLES, DOT, REFERENCES, SUGGESTED_ACTIONS_LAYOUT_MODE } from "../../constants";
import { wrapSuggestionsWithLayout } from "../../templates";
import type { IChatOptions } from "../../models";
import type { DataManager } from "../data-manager.collaborator";
import type { IKendoJQuery } from "../../../core";

export interface ISuggestionRendererContext {
    list: IKendoJQuery;
    options: IChatOptions;
    dataManager: DataManager;
}

export class SuggestionRenderer {
    private context: ISuggestionRendererContext;

    constructor(context: ISuggestionRendererContext) {
        this.context = context;
    }

    renderSuggestedActions(): void {
        const options = this.context.options;
        const lastMessage = this.context.dataManager.getLastMessage();
        const lastSuggestedActions = lastMessage?.suggestedActions || [];
        const suggestedActionsElement = options.suggestedActionsTemplate(lastSuggestedActions);
        const layoutMode = this._getSuggestedActionsLayoutMode(options);
        const suggestedActionsWrapper = wrapSuggestionsWithLayout(suggestedActionsElement, layoutMode, options.dir === "rtl");

        this.removeSuggestedActions();

        this.context.list.append(lastSuggestedActions.length ? suggestedActionsWrapper : "");
        this.context.list.find(`[${REFERENCES.leftScrollButton}]`).addClass(STYLES.disabled);
    }

    removeSuggestedActions(): void {
        this.context.list.find(DOT + STYLES.suggestionGroup).remove();
        this.context.list.find(DOT + STYLES.suggestionScrollWrap).remove();
    }

    private _getSuggestedActionsLayoutMode(options: IChatOptions): typeof SUGGESTED_ACTIONS_LAYOUT_MODE[keyof typeof SUGGESTED_ACTIONS_LAYOUT_MODE] {
        if (options.suggestedActionsLayoutMode) {
            return options.suggestedActionsLayoutMode;
        }
        if (options.suggestedActionsScrollable) {
            return SUGGESTED_ACTIONS_LAYOUT_MODE.SCROLLBUTTONS;
        }
        return SUGGESTED_ACTIONS_LAYOUT_MODE.SCROLL;
    }
}
